export default "__VITE_ASSET__QyTr6OSd__"